import { useDebounce } from 'use-debounce/lib';

export const HINTS = {
  'relates to':
    'Try using a specific verb instead of "relates to". Queries using a specific relationship verb are up to 10x faster.',
  'find * with _type':
    'You can use "Find" followed by the entity type value instead of "Find * with _type=". For example: "Find aws_instance".',
  'find * with _class':
    'You can use "Find" followed by the entity class value instead of "Find * with _class=". For example: "Find Host".',
  '(true or undefined)':
    'You can use "!= false" instead of "= (true of undefined)".',
  '(false or undefined)':
    'You can use "!= true" instead of "= (false of undefined)".',
  '* with (_class|_type)=.*':
    'You can combine _class or _type filters in a simplified syntax like this: "Find (Something|SomethingElse)". For example: "Find (Host|DataStore|Function)".',
  '(_class|_type)=.*':
    'You can combine _class or _type filters in a simplified syntax like this: "Find (Something|SomethingElse)". For example: "Find (Host|DataStore|Function)".',
};

type KeysOfHints = (keyof typeof HINTS)[];
export interface HookProps {
  searchText: string;
}
const useSearchBarHintsLogic = ({ searchText }: HookProps) => {
  const [hint] = useDebounce(getHint(searchText), 750);
  return {
    hint,
  };
};

const getHint = (searchText: string) => {
  // lowercase and remove line breaks
  const formattedSearchText = searchText
    .toLowerCase()
    .replace(/(\r\n|\n|\r)/gm, ' ');
  const hintKey = (Object.keys(HINTS) as KeysOfHints).find((hintKey) =>
    formattedSearchText.includes(hintKey)
  );
  return hintKey ? HINTS[hintKey] : null;
};

export default useSearchBarHintsLogic;
